import Constants from './Constants.js';
import Utils from './Utils.js';

class DomainSpecific {

    COMBINED_VARIABLES = new Array();
    static VARIABLE_DEFAULT = "_DEFAULT";

    //Domain Specific Nodes
    static ALC_EOWP_SIGNUP = "ALC_EOWP_SIGNUP";
    static ALC_EOWP_FORGOTPASS = "ALC_EOWP_FORGOTPASS";

    constructor(){
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_SIGNUP] = new Array();
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_SIGNUP][Constants.EOWP_DOMAIN_HOST_STAGING] = "https://eowp-user2.alc.co.jp/signup";
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_SIGNUP][Constants.EOWP_DOMAIN_HOST_P2_STAGING] = "https://eowp-user2.alc.co.jp/signup";
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_SIGNUP][Constants.EOWP_DOMAIN_HOST_PROD] = "https://eowp-user.alc.co.jp/signup";
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_SIGNUP][DomainSpecific.ALC_EOWP_SIGNUP + DomainSpecific.VARIABLE_DEFAULT] = "https://eowp-user2.alc.co.jp/signup";

        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_FORGOTPASS] = new Array();
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_FORGOTPASS][Constants.EOWP_DOMAIN_HOST_STAGING] = "https://eowp-user2.alc.co.jp/forgot-password";
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_FORGOTPASS][Constants.EOWP_DOMAIN_HOST_P2_STAGING] = "https://eowp-user2.alc.co.jp/forgot-password";
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_FORGOTPASS][Constants.EOWP_DOMAIN_HOST_PROD] = "https://eowp-user.alc.co.jp/forgot-password";
        this.COMBINED_VARIABLES[DomainSpecific.ALC_EOWP_FORGOTPASS][DomainSpecific.ALC_EOWP_FORGOTPASS + DomainSpecific.VARIABLE_DEFAULT] = "https://eowp-user2.alc.co.jp/forgot-password";
    }

    value(domainSpecificNode){
        if(Utils.isEmpty(domainSpecificNode) || Utils.isEmpty(this.COMBINED_VARIABLES[domainSpecificNode])) return "";
        let hostNode = window.location.hostname; //Override this for debugging domain specific
        let isHostNodeRegistered = !Utils.isEmpty(this.COMBINED_VARIABLES[domainSpecificNode][hostNode]);
        return isHostNodeRegistered ? 
            this.COMBINED_VARIABLES[domainSpecificNode][hostNode] : 
            this.COMBINED_VARIABLES[domainSpecificNode][domainSpecificNode + DomainSpecific.VARIABLE_DEFAULT];
    }
}

export default DomainSpecific;
